import script from "./AssetsAndLiabilitiesComparison.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsAndLiabilitiesComparison.vue?vue&type=script&setup=true&lang=js"

import "./AssetsAndLiabilitiesComparison.vue?vue&type=style&index=0&id=580265f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-580265f3"]])

export default __exports__